module.exports = __webpack_public_path__ + "static/media/shells_world_map.2b886094.svg";